import { TextField, TextFieldProps } from '@mui/material';

import ClearSearchButton from './ClearSearchButton';

import SearchIcon from 'modules/common/components/Icons/SearchIcon';

type GenericSearchBarProps = TextFieldProps & {
    onClear?: () => void;
};

function TextFieldSearchBar({ placeholder, onClear = undefined, InputProps, ...props }: GenericSearchBarProps) {
    const renderEndAdornment = () => {
        if (!onClear) {
            return InputProps?.endAdornment;
        }
        if (props.value) {
            return (
                <ClearSearchButton
                    onClick={onClear}
                    sx={{
                        color: 'cement.500',
                    }}
                />
            );
        }
        return null;
    };

    return (
        <TextField
            fullWidth
            placeholder={placeholder}
            name="search"
            InputProps={{
                ...InputProps,
                startAdornment: InputProps?.startAdornment ?? <SearchIcon fontSize="small" sx={{ color: 'black' }} />,
                endAdornment: renderEndAdornment(),
            }}
            {...props}
        />
    );
}

export default TextFieldSearchBar;
